// removed by extract-text-webpack-plugin
module.exports = {"buttons":"CentricUI__BuilderCard__BuilderCardButtons__buttons","goToSeasonTooltip":"CentricUI__BuilderCard__BuilderCardButtons__goToSeasonTooltip","seasonBreadcrumbs":"CentricUI__BuilderCard__BuilderCardButtons__seasonBreadcrumbs","seasonBreadcrumb":"CentricUI__BuilderCard__BuilderCardButtons__seasonBreadcrumb","c8Button":"CentricUI__BuilderCard__BuilderCardButtons__c8Button","fullscreen":"CentricUI__BuilderCard__BuilderCardButtons__fullscreen"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/catalog/product/productCard/components/BuilderCard/BuilderCardButtons.css
// module id = 1592
// module chunks = 10